import { render, staticRenderFns } from "./MyServers.vue?vue&type=template&id=12c8a0ac&scoped=true&"
import script from "./MyServers.vue?vue&type=script&lang=js&"
export * from "./MyServers.vue?vue&type=script&lang=js&"
import style0 from "./MyServers.vue?vue&type=style&index=0&id=12c8a0ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c8a0ac",
  null
  
)

export default component.exports